import NewDeviceTag from './NewDeviceTag';

import { DeviceVehicleAssociationStatus, MultiSelectVehicleAssociationType } from '@cobliteam/common-types';

import { type DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import StatusTag from '@cobliteam/monitoring/src/components/StatusTag';

import useDevicesStore from '../../../store/useDevicesStore';
import { getDeviceVehicleAssociationStatus } from '../../../utils';

interface DeviceStatusCellProps {
  device: DeviceFragment;
  size?: 'xs' | 'sm' | 'md';
}

const DeviceStatusCell = ({ device, size = 'md' }: DeviceStatusCellProps) => {
  const { generalStatus } = device;
  const associationStatus = useDevicesStore((state) => state.associationStatus);

  const isAssociated = associationStatus === MultiSelectVehicleAssociationType.ASSOCIATED_TO_VEHICLE;
  const isLosingData = getDeviceVehicleAssociationStatus(device) === DeviceVehicleAssociationStatus.LOSING_DATA;
  const isDevolution = generalStatus === DeviceGeneralStatus.InDevolution;

  if (isDevolution) return <StatusTag status={generalStatus} showTooltip size={size} />;

  if (isAssociated) return <StatusTag status={generalStatus} showTooltip size={size} />;

  if (isLosingData) return <StatusTag status={DeviceGeneralStatus.LosingData} showTooltip size={size} />;

  if (device.isNew) return <NewDeviceTag size={size} />;

  return null;
};

export default DeviceStatusCell;
